export default __webpack_public_path__ + "static/media/img4.725d2ed2.png";